export const MOBILE = {
  label: 'Mobile',
  value: 'mobile',
  channel: 'mobile',
  navigationLimit: 5,
  tabs: ['screens', 'navigation', 'branding', 'integrations', 'triggers', 'profile-viewer', 'products'],
  screenTemplates: [
    {
      label: 'Accounts Dashboard',
      template: 'AccountsDashboardScreen',
      preset: '',
      thumbnail: 'mobile-accounts-dashboard-screen.png',
      content: {},
    },
    { label: 'Article', template: 'ArticleScreen', preset: '', thumbnail: 'mobile-article-screen.png', content: {} },
    { label: 'Carousel', template: 'CarouselScreen', preset: '', thumbnail: 'mobile-carousel-screen.png', content: {} },
    {
      label: 'Cart',
      template: 'CartScreen',
      preset: '',
      thumbnail: 'mobile-cart-screen.png',
      hidden: true,
      content: {},
    },
    { label: 'Form', template: 'FormScreen', preset: '', thumbnail: 'mobile-form-screen.png', content: {} },
    { label: 'Grid', template: 'GridScreen', preset: '', thumbnail: 'mobile-grid-screen.png', content: {} },
    { label: 'Home', template: 'HomeScreen', preset: '', thumbnail: 'mobile-hero-screen.png', content: {} },
    { label: 'List', template: 'ListScreen', preset: '', thumbnail: 'mobile-list-screen.png', content: {} },
    { label: 'Product', template: 'ProductScreen', preset: '', thumbnail: 'mobile-product-screen.png', content: {} },
    {
      label: 'Settings',
      template: 'SettingsScreen',
      preset: '',
      thumbnail: 'mobile-webview-screen.png',
      hidden: true,
      content: {},
    },
    { label: 'WebView', template: 'WebViewScreen', preset: '', thumbnail: 'mobile-webview-screen.png', content: {} },
  ],
  freeformTemplates: [
    {
      label: 'Product',
      template: 'FreeformScreen',
      preset: 'product',
      thumbnail: 'mobile-product-screen.png',
      content: [
        { meta: { component: 'productImage' }, content: {} },
        { meta: { component: 'productTitle' }, content: {} },
        { meta: { component: 'productAddToCartButton' }, content: {} },
        { meta: { component: 'productDescription' }, content: {} },
      ],
    },
    {
      label: 'Empty',
      template: 'FreeformScreen',
      preset: '',
      thumbnail: 'mobile-unknown.png',
      content: [],
    },
    {
      label: 'Home',
      template: 'FreeformScreen',
      preset: 'home',
      thumbnail: 'mobile-hero-screen.png',
      content: [],
    },
    {
      label: 'Category',
      template: 'FreeformScreen',
      preset: 'category',
      thumbnail: 'mobile-list-screen.png',
      content: [
        {
          meta: {
            component: 'banner',
          },
          content: {
            size: 'medium',
            image: 'https://demo-system-next.s3.amazonaws.com/helium/assets/women.jpeg',
            title: 'ALWAYS COMFORTABLE',
            layout: 'full-overlay',
            linkTo: 'DgXwjE2AP',
            subtitle: 'Our warmest jackets',
            horizontalAlignment: 'center',
          },
        },
        {
          meta: {
            component: 'list',
          },
          content: {
            items: [],
            layout: 'vertical/grid',
            itemsInRow: 1,
            itemRenderer: 'category-item-renderer',
          },
        },
      ],
    },
    {
      label: 'User Details (DX Demo 2.0)',
      template: 'FreeformScreen',
      preset: 'userDetails',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'profilePicture',
          },
          content: { layout: 'vertical-list' },
        },
        {
          meta: {
            component: 'loyaltyDetails',
          },
          content: {},
        },
        {
          meta: {
            component: 'wishList',
          },
          content: { wishListTitle: ' YOUR WISH LIST', emptyWishListLabel: 'EMPTY WISH LIST' },
        },
      ],
    },
    {
      label: 'Web View (DX Demo 2.0)',
      template: 'FreeformScreen',
      preset: 'webView',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'webView',
          },
          content: { url: 'https://www.adobe.come' },
        },
      ],
    },
    {
      label: 'Article',
      template: 'FreeformScreen',
      preset: 'article',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'image',
          },
          content: {
            src: 'https://demo-system-next.s3.amazonaws.com/helium/assets/blog4.jpeg',
            weight: 'bold',
            imageSize: 'large',
            imageResize: 'cover',
          },
        },
        {
          meta: {
            component: 'title',
          },
          content: {
            size: 'large',
            text: "Begginer's luck",
            weight: 'bold',
          },
        },
        {
          meta: {
            component: 'title',
          },
          content: {
            size: 'medium',
            text: 'How to leverage your environment to ease beginners aches and pains',
            weight: 'regular',
          },
        },
        {
          meta: {
            component: 'htmlText',
          },
          content: {
            text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tincidunt risus nunc, vitae iaculis lectus consequat eget. Nunc eu justo finibus diam efficitur blandit. Nunc hendrerit ut elit non lacinia. Vivamus aliquet pulvinar urna at cursus. Quisque suscipit gravida est, sed rutrum urna accumsan ut. Sed elit metus, dignissim vitae mauris nec, pellentesque venenatis dolor. Suspendisse potenti. Morbi quis mauris consequat, pulvinar velit vel, malesuada lacus. Pellentesque facilisis tortor tortor. Nunc ullamcorper cursus eros, ac scelerisque nisl dignissim mattis. Nam hendrerit in tellus vitae sodales. Curabitur sodales purus quis rutrum consectetur. Etiam sit amet est sed dui semper semper. Vivamus aliquam nulla mattis, faucibus lectus vulputate, lobortis orci. Praesent gravida porttitor leo non tincidunt.</p><p>In vulputate dui mauris, non condimentum urna ullamcorper vel. Cras pulvinar nisi orci, at fringilla ante varius ut. Duis quis mollis lacus. Suspendisse potenti. Nulla interdum iaculis augue, eu ultricies diam mattis at. Aliquam fermentum quis orci vitae ultricies. In hac habitasse platea dictumst. Nulla facilisi. Aenean ut quam faucibus, convallis dui et, vulputate dolor. Sed imperdiet, dolor sit amet cursus mollis, tortor metus maximus metus, ut ullamcorper elit nulla et lorem. Mauris dapibus nulla id consequat sagittis. Vestibulum laoreet convallis lorem ac congue.</p><p>Pellentesque rutrum non libero id rhoncus. Proin ornare tempor sapien at euismod. Etiam faucibus sem et mi vestibulum sollicitudin. Integer consequat sagittis enim a aliquam. In est tortor, hendrerit quis purus in, ornare dictum massa. Nam turpis mauris, molestie id lorem vel, finibus efficitur purus. Nunc et nisl ante. Sed eleifend placerat dapibus. Sed gravida neque vel lacinia rutrum. Phasellus ultrices eget leo eget placerat.</p><p>Integer mattis, diam eget interdum scelerisque, nulla turpis tristique nunc, a fermentum ex ex quis magna. Nulla a pharetra orci, in egestas ligula. Aliquam interdum arcu sed lacus convallis tempus. Vestibulum nibh arcu, condimentum at lectus quis, semper mollis nunc. Nulla facilisi. Morbi faucibus purus vitae tempus ultricies. Integer molestie massa risus, id porttitor risus venenatis posuere. Cras quis ultricies justo. Cras nec justo neque. Pellentesque maximus ante nec pellentesque convallis. Vivamus id ornare lorem. Aliquam consequat arcu at urna vulputate aliquet.</p>',
          },
        },
      ],
    },
    {
      label: 'Checkout (DX Demo 2.0)',
      template: 'FreeformScreen',
      preset: 'checkout',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'userShippingAddress',
          },
          content: {
            title: 'SHIPPING ADDRESS',
          },
        },
        {
          meta: {
            component: 'shippingMethods',
          },
          content: {
            title: 'Shipping Method',
            options: [
              {
                label: 'Standard Shipping -  5-14 business days',
                value: '5',
              },
              {
                label: 'GROUND Shipping -  3-7 business days',
                value: '10',
              },
              {
                label: 'PRIORITY Shipping -  2 business days',
                value: '15',
              },
              {
                label: 'Express Shipping -  1 business days',
                value: '25',
              },
            ],
          },
        },
        {
          meta: {
            component: 'paymentMethods',
          },
          content: {
            title: 'Payment Methods',
            options: [
              {
                label: 'CREDIT OR DEBIT CARD',
                value: '0',
              },
              {
                label: 'PAYPAL',
                value: '1',
              },
            ],
          },
        },
        {
          meta: {
            component: 'reviewOrderButton',
          },
          content: {
            linkTo: 'reviewOrder',
            buttonLabel: 'REVIEW ORDER',
          },
        },
      ],
    },
    {
      label: 'Review Order (DX Demo 2.0)',
      template: 'FreeformScreen',
      preset: 'reviewOrder',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'shippingSummary',
          },
          content: {},
        },
        {
          meta: {
            component: 'cartItems',
          },
          content: {
            layout: 'vertical-list',
          },
        },
        {
          meta: {
            component: 'cartSummary',
          },
          content: {
            label: 'TOTAL',
            showDiscount: 'true',
            showPromoCode: 'false',
            promoCodeLabel: 'PROMO CODE',
            showShippingCharge: 'true',
          },
        },
        {
          meta: {
            component: 'orderButtons',
          },
          content: {
            buttonLabel: 'CONFIRM ORDER',
          },
        },
      ],
    },
    {
      label: 'Cart (DX Demo 2.0)',
      template: 'FreeformScreen',
      preset: 'cart',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'cartItems',
          },
          content: {
            layout: 'vertical-list',
          },
        },
        {
          meta: {
            component: 'cartSummary',
          },
          content: {
            label: 'TOTAL',
            showDiscount: 'false',
            showPromoCode: 'true',
            promoCodeLabel: 'PROMO CODE',
            showShippingCharge: 'false',
          },
        },
        {
          meta: {
            component: 'cartButtons',
          },
          content: {
            emptyButtonLabel: 'EMPTY CART',
            showCheckoutButton: 'true',
            checkoutButtonLabel: 'CHECKOUT',
            showEmptyCartButton: 'true',
          },
        },
      ],
    },
    {
      label: 'Registration',
      template: 'FreeformScreen',
      preset: 'registration',
      thumbnail: 'mobile-form-screen.png',
      content: [
        {
          meta: {
            order: 0,
            layout: 'vertical',
            component: 'panel',
            panelTitle: 'CREATE AN ACCOUNT',
            showBorder: false,
            panelPadding: 10,
          },
          content: [
            {
              meta: {
                order: 0,
                component: 'profilePicture',
              },
              content: {
                formId: 'registration',
                layout: 'vertical-list',
                enabled: 'true',
              },
            },
            {
              meta: {
                order: 1,
                component: 'textField',
              },
              content: {
                name: 'firstName',
                path: 'person.name.firstName',
                label: 'First Name',
                formId: 'registration',
                preFill: true,
                placeholder: '',
              },
            },
            {
              meta: {
                order: 1,
                component: 'textField',
              },
              content: {
                name: 'lastName',
                path: 'person.name.lastName',
                label: 'Last Name',
                formId: 'registration',
                preFill: true,
                placeholder: '',
              },
            },
            {
              meta: {
                order: 1,
                component: 'textField',
              },
              content: {
                name: 'email',
                path: 'person.email',
                label: 'Email',
                formId: 'registration',
                preFill: true,
                placeholder: '',
              },
            },
            {
              meta: {
                order: 1,
                component: 'textField',
              },
              content: {
                name: 'mobileNumber',
                path: 'person.mobileNumber',
                label: 'Mobile Number',
                formId: 'registration',
                preFill: true,
                placeholder: '',
              },
            },
            {
              meta: {
                order: 1,
                component: 'textField',
              },
              content: {
                name: 'street',
                path: 'person.address.street',
                label: 'Street',
                formId: 'registration',
                preFill: true,
                placeholder: '',
              },
            },
            {
              meta: {
                order: 0,
                component: 'textField',
              },
              content: {
                name: 'city',
                path: 'person.address.city',
                label: 'City',
                formId: 'registration',
                preFill: true,
                placeholder: '',
              },
            },
            {
              meta: {
                order: 1,
                component: 'formSubmitButton',
              },
              events: ' --- ',
              formId: '',
              content: {
                label: 'REGISTER',
                events: 'customEvent',
                formId: 'registration',
                message: 'Thank you',
                customEvent: 'registration',
              },
              webhookUrl: '',
              customEvent: 'custom',
            },
          ],
        },
      ],
    },
  ],

  defaultTemplate: {
    name: 'new-screen',
    title: `New Screen`,
    template: 'FreeformScreen',
    preset: 'home',
    icon: 'home',
    content: [{ meta: { component: 'banner' }, content: { title: 'Hello World!' } }],
  },
  defaultComponent: { meta: { component: 'title' }, content: { title: 'Lorem Ipsum', subtitle: 'dorol sit amet...' } },
  unknownTemplate: 'mobile-unknown.png',
  triggerTypes: ['beacon'],
  bannerPositionOptions: [],
  navigationAlignmentOptions: [
    { label: 'Left', value: 'left' },
    { label: 'Center', value: 'center', default: true },
    { label: 'Right', value: 'right' },
  ],
  authOptions: [
    { label: 'Always', value: 'always' },
    { label: 'Optional', value: 'optional' },
    { label: 'None', value: 'none' },
  ],
  cartStorageOptions: [
    { label: 'Local', value: 'local', default: true },
    { label: 'AEP', value: 'aep' },
  ],
  displayInboxOptions: [
    { label: 'Hidden', value: 'none' },
    { label: 'Main Navigation', value: 'mainNavigation', default: true },
  ],
}
